import { useScrolled } from '../hooks/useScrolled';
import { useTheme } from '../hooks/useTheme';
import { LangToggle } from './LangToggle';
import type { Locale } from '../i18n/ui';

interface Props {
  t: (key: string) => string;
  locale: Locale;
}

const CTA_URL = 'https://wa.me/5519997391955';

export function Nav({ t, locale }: Props) {
  const scrolled = useScrolled(12);
  const { toggle: toggleTheme } = useTheme();

  return (
    <header className={`nav${scrolled ? ' is-scrolled' : ''}`} id="nav">
      <div className="container nav-inner">
        <a className="logo" href="#top" aria-label="hook home">
          <svg width="28" height="28" viewBox="0 0 32 32" aria-hidden="true">
            <defs>
              <linearGradient id="logo-grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#0B1051" />
                <stop offset="55%" stopColor="#495ae1" />
                <stop offset="100%" stopColor="#6BA1CC" />
              </linearGradient>
            </defs>
            <circle cx="16" cy="16" r="15" fill="url(#logo-grad)" />
            <path
              d="M10 8 L10 24 M10 16 L18 16 C20 16 22 14 22 12 M22 12 L22 24"
              stroke="#fff"
              strokeWidth="2.4"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span>hook</span>
        </a>

        <div className="nav-meta">
          <span className="meta-text mono">
            <span className="status-dot"></span>
            {t('nav.status')}
          </span>
          <LangToggle currentLocale={locale} />
          <button onClick={toggleTheme} className="theme-toggle" aria-label="Alternar tema">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="5" />
              <line x1="12" y1="1" x2="12" y2="3" />
              <line x1="12" y1="21" x2="12" y2="23" />
              <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
              <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
              <line x1="1" y1="12" x2="3" y2="12" />
              <line x1="21" y1="12" x2="23" y2="12" />
              <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
              <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
          </button>
          <a className="btn" href={CTA_URL} target="_blank" rel="noopener noreferrer">
            {t('nav.cta')} <span className="arr">↗</span>
          </a>
        </div>
      </div>
    </header>
  );
}
